import { trackEvent as t } from '../track';

export interface ThemeProps {
  '[Metadata] Set Theme': string;
}

export const user = {
  create: () => t('[User] Create account'),
  join: () => t('[User] Join organization'),
  leave: () => t('[User] Leave organization'),
  signinView: () => t('[User] Sign in view'),
  signin: () => t('[User] Sign in'),
  signout: () => t('[User] Sign out'),
  toggleTheme: (props: ThemeProps) => t('[User] ToggleTheme', props),
};
